import React from 'react'

class PinRecoverList extends React.Component {
  formatTime(timestamp) {
    const d = new Date(timestamp);
    d.setHours(d.getHours() - 2);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  }

  render() {
    return (
      <table className="pinrecover-table">
        <thead>
          <tr>
            <th>Máquina</th>
            <th>Fecha/Hora</th>
            <th>Tipo</th>
            <th>Pin / Trabajador</th>
            <th>Evento</th>
            <th>Descripción</th>
          </tr>
        </thead>
        <tbody>
          {this.props.audits.map(audit => (
            <tr key={audit._id}>
              <td>{audit.Machine ? audit.Machine.Serial : '-'}</td>
              <td>{this.formatTime(audit.TimeStamp)}</td>
              <td><span className="pinrecover-badge">{audit.Categoria}</span></td>
              <td>{audit.WorkerSession}</td>
              <td>{audit.Evento || ''}</td>
              <td>{audit.Description || ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

export default PinRecoverList

